import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormRectangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-rectangle"} maskId="square-filled-radius-0-stroke-1-IconFormRectangle"><path d="M22 20H2V4H22V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormRectangle;
